interface FullLogoProps {
  className?: string;
}

export function FullLogo({ className }: FullLogoProps) {
  return (
    <svg
      className={`text-text-primary ${className ?? ""}`}
      fill="none"
      height="32"
      viewBox="0 0 162 32"
      width="162"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6705 31.282V18.2626C14.6705 15.0912 13.574 13.6128 11.0029 13.6128C8.1782 13.6128 6.99705 15.176 6.99705 18.3474V31.282H0V7.82116H6.53463V10.3143H6.61919C8.09364 7.90594 10.16 7.01838 12.9847 7.01838C17.1993 7.01838 21.6702 9.38433 21.6702 16.3179V31.282H14.6705Z"
        fill="currentColor"
      />
      <path
        d="M38.1535 32C31.0296 32 25.5493 26.717 25.5493 19.5291C25.5493 12.3411 31.1564 7.05813 38.1535 7.05813C45.1505 7.05813 50.7577 12.3411 50.7577 19.4443C50.7577 26.5474 45.1928 31.9973 38.1535 31.9973V32ZM43.7606 19.5291C43.7606 16.4001 41.401 13.6102 38.1112 13.6102C35.0328 13.6102 32.5463 16.3153 32.5463 19.5291C32.5463 22.7428 34.9905 25.4479 38.1535 25.4479C41.3164 25.4479 43.7606 22.6581 43.7606 19.5291Z"
        fill="currentColor"
      />
      <path
        d="M54.2985 31.282V0H61.2955V31.2793H54.2985V31.282Z"
        fill="currentColor"
      />
      <path
        d="M66.3557 5.32803V0H73.3528V5.32538H66.3557V5.32803ZM66.3557 31.282V7.82116H73.3528V31.282H66.3557Z"
        fill="currentColor"
      />
      <path
        d="M107.334 31.282V18.6441C107.334 14.9667 106.153 13.6128 103.751 13.6128C101.095 13.6128 99.8718 15.2184 99.8718 18.305V31.282H92.8747V18.3474C92.8747 15.3032 91.7781 13.6128 89.3762 13.6128C86.636 13.6128 85.4126 15.388 85.4126 18.6441V31.282H78.4156V7.82116H84.9502V10.3143H85.0348C86.2582 8.11525 88.491 7.01838 91.4848 7.01838C94.4787 7.01838 96.7538 8.53916 98.2282 11.2019C99.914 8.53916 102.443 7.01838 105.648 7.01838C110.875 7.01838 114.334 10.2322 114.334 16.7816V31.2793H107.337L107.334 31.282Z"
        fill="currentColor"
      />
      <path
        d="M119.264 5.32803V0H126.261V5.32538H119.264V5.32803ZM119.264 31.282V7.82116H126.261V31.282H119.264Z"
        fill="currentColor"
      />
      <path
        d="M132.923 31.282V13.1465H129.467V7.82116H132.923V0H139.92V7.82116H143.292V13.1465H139.92V31.282H132.923Z"
        fill="currentColor"
      />
      <path
        d="M146.291 1.46678e-06V5.2724H153.021L147.218 11.0906L150.936 14.8183L156.742 9.00017V15.6847H162V1.46678e-06H146.291Z"
        fill="#7600FF"
      />
    </svg>
  );
}
